export default __webpack_public_path__ + "static/media/IMG_4470.241fd553.jpg";